module.exports = __webpack_public_path__ + "TB_Powerup_Ambience_B.wav.2f1e93d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_Ambience_B.wav.mp3
// module id = 503
// module chunks = 0